const journeys = {
  JourneysList: {
    title: "Journeys Assistant",
  },
  JourneysFloatingBar: {
    buttonText: "Next",
    patientDetailsText: "Next review lab results and interpretation",
    interpretationDetailsText: "Next review suggested products and resources",
  },
};

export { journeys };
